import React from 'react';
import styles from '../styles/FirstStart.module.css'; // если используешь CSS-модули
import CreateProjectButton_firsttime from './CreateProjectButton_firsttime';

const FirstStart = ({user_id}) => {
  return (
    <div className={styles.container}>
    <div className={styles.wrapper}>
      <h1 className={styles.title}>Добро пожаловать в pulseads.ru!</h1>
      <p className={styles.text}>
        Мы рады видеть вас! Сервис создан для удобной работы с объявлениями на Авито:
        автоматическая загрузка, управление и отслеживание статистики.
      </p>
      <p className={styles.subtext}>Начните с добавления проекта.</p>
      <img className={styles.img} src="/primer_add_project.png" alt="Пример добавлени проекта" />
      
      <ul className={styles.ul}>
        <li className={styles.li}>
           Укажите название проекта для вашего удобства.  
        </li>
        <li className={styles.li}>
            Яндекс токен необходим для удобного управления фотографиями в объявлениях,
             создания накладок, уникализации, но не обязателен если вы используете свои готовые ссылки.
        </li>
        <li className={styles.li}>
            Avito client ID, Client Secret необходимы для получения статусов выгрузки
             а также для получения статистики по объявлениям, их можно получить 
             на сайте авито в личном кабинете на профессиональном тарифе. 
        </li>
        <li className={styles.li}>
            Для удобства хранения ваших данных добавьте ссылку на вашу гугл таблицу 
            предварительно предоставив доступ для редоктирования по ссылке (<a href="https://pulseads.ru/bz" target="_blank">подробнее в инструкции</a>).
        </li>
        <li className={styles.li}>
            Чтобы сервис понимал с какими листами работать и не добавлять в xml файл 
            для загрузки на авито черновики и прочие листы перечислети их в поле "Листы" 
            в качестве разделителя используйте вертикальную черту | с пробелом до и после черты пример: 
            Из Авито | Из Авито2. Поле Добавить шаблон станет активным после указания ссылки на гугл таблицу.
        </li>
        <li className={styles.li}>
            По всем взникающим вопросам обращайтесь в телеграм <a href="https://t.me/FaveAdsbot" target="_blank">бота поддержки</a>, мы с радостью вам поможем решить все возникающие вопросы.
        </li>
      </ul>
      <div className={styles.create_project}>
                            <CreateProjectButton_firsttime user_id={user_id} /> 
                        </div>
    </div>
    </div>
  );
};

export default FirstStart;
